import { materialLimitsAPI } from "./api";

export const getProjectTypes = async () => {
  const res = await materialLimitsAPI.getProjectTypes();
  return res?.data ?? [];
};

export const getMaterialLimits = async (project_type_id) => {
  if (!project_type_id) return [];
  const res = await materialLimitsAPI.getMaterialLimits(project_type_id);
  return res?.data ?? [];
};

export const searchMaterialsForLimit = async (material_name, signal) => {
  if (!material_name || material_name.length < 2) return [];
  const res = await materialLimitsAPI.searchMaterials(
    { material_name },
    signal
  );
  const list = res?.data ?? [];
  return list.map((item) => ({
    ...item,
    label: item.unit_name
      ? `${item.material_name} (${item.unit_name})`
      : item.material_name,
  }));
};

export const addMaterialLimit = async (project_type_id, body) => {
  const res = await materialLimitsAPI.addMaterialLimit(project_type_id, body);
  return res?.data ?? res;
};

export const updateMaterialLimit = async (project_type_id, body) => {
  const res = await materialLimitsAPI.updateMaterialLimit(
    project_type_id,
    body
  );
  return res?.data ?? res;
};

export const deleteMaterialLimit = async (project_type_id, limit_id) => {
  const res = await materialLimitsAPI.deleteMaterialLimit(
    project_type_id,
    limit_id
  );
  return res?.data ?? res;
};

export const materialLimitsColumns = [
  {
    name: "material_name",
    field: "material_name",
    label: "Материал",
    align: "left",
  },
  {
    name: "unit_name",
    field: "unit_name",
    label: "Ед. изм.",
    align: "center",
  },
  {
    name: "limit_amount",
    field: "limit_amount",
    label: "Лимит",
    align: "right",
  },
  {
    name: "actions",
    label: "",
    align: "center",
    field: "actions",
  },
];
